import { useState } from 'react';

import { useUserSettingsTranslation } from '@app/widgets/contacts-and-settings/hooks/useUserSettingsTranslation';
import { useRevokePasskeyMutation } from '@app/widgets/contacts-and-settings/queries/queryTyping/revokePasskey';

export const usePasskeyRevoke = ({ getRegisteredPasskeys }: {getRegisteredPasskeys: () => void}) => {
  const { t } = useUserSettingsTranslation();

  const [passkeyRevokeError, setPasskeyRevokeError] = useState('');

  const handleError = (message?: string) => {
    setPasskeyRevokeError(message || t(
      'passkey-revoke.revoke-dialog.error|Passkey revoke dialog error',
      'An error occurred while trying to delete the passkey',
    ));
  };
  const [revokePasskey, {
    loading,
  }] = useRevokePasskeyMutation({
    onError: () => handleError(),
    onCompleted: (data) => {
      if (data.revokePasskey.success) {
        getRegisteredPasskeys();
      }
      if (!data.revokePasskey.success) {
        handleError(data.revokePasskey.message);
      }
    },
  });
  return {
    isLoading: loading,
    passkeyRevokeError,
    revokePasskey: (passkeyId: string) => revokePasskey({ variables: { revokePasskeyParams: { passkeyId } } }),
  };
};
